{
  "title": "Stripe & Premium",
  "intro": "L’argent réel, séparé de l’Anima. Les données Stripe restent accessibles uniquement aux propriétaires.",
  "openStripe": "Ouvrir Stripe",
  "configuration": "Configuration Stripe",
  "navigation": "Gestion des paiements",
  "ready": "Checkout, portail client et signature du webhook sont configurés.",
  "setupNeeded": "L’offre doit être configurée avant d’ouvrir les abonnements.",
  "setup": "Configurer l’offre à 3,99 €",
  "setupConfirm": "Cette action crée ou réutilise le produit mensuel à 3,99 €, taxes incluses le cas échéant, et un portail permettant la résiliation en fin de période. Elle ne crée aucun abonnement ni paiement. L’environnement affiché doit être celui que tu souhaites configurer.",
  "missing": {
    "key": "Clé serveur Stripe absente.",
    "webhook": "Signature du webhook obligatoire : STRIPE_WEBHOOK_SECRET.",
    "price": "Tarif mensuel à initialiser ou STRIPE_PREMIUM_PRICE_ID à fournir.",
    "portal": "Portail client à initialiser ou STRIPE_PORTAL_CONFIGURATION_ID à fournir.",
    "activation": "Les paiements réels ne sont pas activés, ou une clé de test est utilisée en production."
  },
  "mode": {
    "test": "Environnement de test — aucun argent réel",
    "live": "Compte Stripe réel",
    "unconfigured": "Stripe non configuré"
  },
  "tabs": {
    "overview": "Vue d’ensemble",
    "subscriptions": "Abonnements",
    "payments": "Paiements",
    "customers": "Clients",
    "expenses": "Dépenses",
    "activity": "Suivi"
  },
  "utc": "Périodes et dépenses en UTC",
  "range": "Période de suivi",
  "days_one": "{{count}} jour",
  "days_other": "{{count}} jours",
  "refresh": "Actualiser les chiffres",
  "customers": "Clients ANIDEX",
  "customersHint": "Dossiers Stripe liés à un compte du jeu",
  "activeSubscriptions": "Abonnements actifs",
  "paying_one": "{{count}} client avec accès payé en cours",
  "paying_other": "{{count}} clients avec accès payé en cours",
  "mrr": "MRR théorique",
  "mrrHint": "Actifs × 3,99 €, hors remises, fiscalité et incidents",
  "operatingCosts": "Coûts externes saisis",
  "operatingCostsHint": "Dépenses réelles déclarées pour la période",
  "attention": "{{alerts}} alertes ouvertes, {{webhooks}} webhooks en erreur et {{pastDue}} abonnements en retard.",
  "inspect": "Vérifier le suivi",
  "revenueChart": "Recettes, remboursements et frais",
  "revenueHint": "Mouvements du compte Stripe, en euros. Les autres devises restent séparées ci-dessous.",
  "gross": "Encaissements bruts",
  "received": "Encaissé",
  "refunds": "Remboursements et annulations nets",
  "fees": "Frais Stripe",
  "net": "Après frais et remboursements",
  "afterCosts": "Après les coûts externes saisis",
  "available": "Solde Stripe disponible",
  "pending": "Solde Stripe en attente",
  "accountingNote": "Les recettes et frais proviennent des mouvements Stripe. Les virements vers la banque ne sont pas des dépenses. Les dépenses d’hébergement, d’emails ou autres doivent être saisies : Stripe ne les connaît pas. Ces indicateurs ne sont pas un résultat comptable ; taxes, litiges et autres ajustements doivent être rapprochés avec les rapports Stripe. Ne pas additionner des devises différentes.",
  "canceling_one": "{{count}} renouvellement est programmé pour s’arrêter.",
  "canceling_other": "{{count}} renouvellements sont programmés pour s’arrêter.",
  "subscriptionsCaption": "Abonnements ANIDEX synchronisés depuis Stripe. Les droits dépendent de la période réellement payée.",
  "paymentsCaption": "Paiements du compte Stripe, y compris les paiements ponctuels et les tentatives non encaissées.",
  "customersCaption": "Clients du compte Stripe. Les dossiers non liés peuvent correspondre à des tests ou à d’autres produits.",
  "player": "Joueur",
  "state": "État",
  "paidAccess": "Période payée",
  "renewal": "Prochaine échéance",
  "actions": "Actions",
  "suspended": "Accès suspendu",
  "notPaid": "Non confirmée",
  "canceledRenewal": "Renouvellement arrêté",
  "none": "—",
  "sync": "Resynchroniser",
  "cancel": "Arrêter le renouvellement",
  "resume": "Reprendre le renouvellement",
  "noSubscriptions": "Aucun abonnement ANIDEX dans cet environnement",
  "payment": "Paiement",
  "refunded": "Remboursé",
  "noEmail": "Email non renseigné",
  "receipt": "Reçu",
  "refund": "Rembourser",
  "noPayments": "Aucun paiement dans cet environnement",
  "customer": "Client",
  "email": "Email de facturation",
  "created": "Création",
  "openPlayer": "Ouvrir le joueur",
  "notLinked": "Non lié à ANIDEX",
  "noCustomers": "Aucun client Stripe",
  "expensesTitle": "Dépenses de fonctionnement",
  "expensesHint": "Ajoute les frais externes, pas les frais Stripe déjà calculés ni les virements bancaires. Les montants sont en euros.",
  "addExpense": "Ajouter une dépense",
  "expenseLabel": "Libellé",
  "category": "Catégorie",
  "date": "Date du paiement",
  "amount": "Montant",
  "amountCurrency": "Montant en {{currency}}",
  "edit": "Modifier",
  "delete": "Supprimer",
  "noExpenses": "Aucune dépense saisie",
  "categories": {
    "infrastructure": "Hébergement et stockage",
    "email": "Emails et communication",
    "other": "Autre coût de fonctionnement"
  },
  "activityHint": "Les 50 dernières alertes et notifications techniques de cet environnement. L’historique complet et les relances d’événements sont disponibles dans Stripe Workbench.",
  "alerts": "Dossiers à vérifier",
  "alertsKinds": {
    "refund": "Facture intégralement remboursée",
    "dispute": "Paiement contesté",
    "fraud": "Alerte de suspicion de fraude"
  },
  "noAlerts": "Aucune alerte enregistrée.",
  "resolved": "Vérifié",
  "resolve": "Lever la suspension",
  "webhooks": "Synchronisation Stripe",
  "attempts_one": "{{count}} tentative",
  "attempts_other": "{{count}} tentatives",
  "noWebhooks": "Aucun événement reçu. Vérifie l’endpoint avant d’ouvrir les paiements.",
  "retryHint": "En cas d’échec, Stripe réessaie automatiquement. Tu peux aussi relancer l’événement depuis Workbench. Une resynchronisation d’abonnement relit l’état actuel, sans créer de paiement.",
  "refundReason": "Motif du remboursement",
  "refundReasons": {
    "requested_by_customer": "Demande du client",
    "duplicate": "Paiement en double",
    "fraudulent": "Paiement frauduleux"
  },
  "refundConfirm": "Reste remboursable : {{max}}. Vérifie le montant et le motif avant d’envoyer cette demande à Stripe.",
  "refundWarning": "Un remboursement ne résilie pas l’abonnement. Un remboursement intégral de la facture courante suspend l’accès Premium ; vérifie aussi le renouvellement pour éviter un nouveau prélèvement.",
  "cancelConfirm": "Le renouvellement sera arrêté à la fin de la période. L’accès déjà payé reste disponible jusqu’à son échéance normale.",
  "resumeConfirm": "Le prélèvement mensuel reprendra à la prochaine échéance. Cette action n’ajoute ni booster ni ressource de jeu.",
  "deleteConfirm": "Supprimer cette ligne du suivi des coûts ? L’action restera dans le journal d’administration.",
  "resolveWarning": "Ne lève la suspension qu’après vérification du dossier dans Stripe. Cela peut rétablir l’accès pendant la période payée restante ; ce n’est ni un remboursement, ni une résolution du litige auprès de Stripe.",
  "resolutionReason": "Motif de la décision, au moins 10 caractères",
  "confirm": {
    "setup": "Configurer l’offre Stripe",
    "cancel": "Arrêter ce renouvellement",
    "resume": "Reprendre ce renouvellement",
    "refund": "Confirmer un remboursement",
    "expense": "Enregistrer une dépense",
    "deleteExpense": "Supprimer une dépense",
    "resolve": "Vérifier et lever une suspension"
  },
  "confirmAction": "Confirmer l’action",
  "close": "Annuler",
  "saving": "Traitement en cours…",
  "saved": "Action enregistrée",
  "failed": "L’action n’a pas abouti",
  "amountInvalid": "Indique un montant valide, positif et inférieur ou égal au reste remboursable.",
  "refundDone": "Remboursement confirmé par Stripe",
  "refundPending": "Remboursement demandé, en attente de confirmation",
  "refundNotConfirmed": "Remboursement non confirmé : vérifie son état dans Stripe avant de retenter",
  "pagination": "Pages de résultats",
  "previous": "Précédent",
  "next": "Suivant",
  "page": "Page {{count}}",
  "status": {
    "active": "Actif",
    "trialing": "Essai",
    "past_due": "En retard",
    "unpaid": "Impayé",
    "canceled": "Résilié",
    "paused": "Suspendu",
    "incomplete": "À finaliser",
    "incomplete_expired": "Expiré sans paiement",
    "unsupported": "Offre non conforme",
    "succeeded": "Encaissé",
    "pending": "En attente",
    "processing": "En cours",
    "requires_payment_method": "Moyen de paiement requis",
    "requires_action": "Action du client requise",
    "requires_confirmation": "Confirmation requise",
    "requires_capture": "Capture requise",
    "processed": "Synchronisé",
    "failed": "Échec"
  }
}
